<template>
  <v-col cols="12">
    <v-list class="py-0 rule-list" dense>
      <v-list-item
        v-for="rule in rules"
        :key="rule.id"
        @click="$emit('editRule', rule)"
        class="rule-element hover-list-element px-2"
      >
        <v-list-item-content>
          <v-row no-gutters>
            <v-col cols="auto" align-self="center">
              <v-list-item-title style="max-width: 21vw">
                <v-row no-gutters class="flex-nowrap">
                  <v-col cols="auto">
                    <v-tooltip bottom color="font" max-width="300">
                      <template #activator="{ on }">
                        <div v-on="on" class="text-body-2 font-weight-regular text-truncate py-0">
                          {{ rule.name }}
                        </div>
                      </template>
                      <div style="word-break: break-all;">
                        {{ rule.name }}
                      </div>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <dots-menu @delete="$emit('deleteRule', rule.id)" :items="dotsItems" font-size="19px"></dots-menu>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'ModelingRulesList',
  components: { DotsMenu },
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dotsItems: [{ name: 'delete' }],
  }),
};
</script>

<style scoped lang="scss">
.rule-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.rule-list {
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
</style>
